import React from 'react';
import { PreviewItemContainer, PreviewItemImage } from '../style';
import { Text } from '../../../../UI/Text';
import {
    convertPreviewItemKeyToTitle,
    convertPreviewItemKeyToDescription,
    getPreviewItemBackgroundImage,
} from '../utils';
import { colorNames } from '../../../../../Constants/colors';

export const PreviewItem = ({ type, selectItem }) => {
    return (
        <PreviewItemContainer>
            <PreviewItemImage background={getPreviewItemBackgroundImage(type)} onClick={selectItem} />
            <Text marginBottom={'4px'} alignCenter={true} color={colorNames.GREY} weight={'bold'}>
                {convertPreviewItemKeyToTitle(type)}
            </Text>
            <Text marginBottom={'16px'} alignCenter={true} fontSize={12}>
                {convertPreviewItemKeyToDescription(type)}
            </Text>
        </PreviewItemContainer>
    );
};

PreviewItem.defaultProps = {
    type: 0,
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Previews/PreviewItem.js